export enum FILTER_LABEL {
  ASSETS_HEALTH_STATUS = 'Assets Health Status',
  ASSETS_CONDITION = 'Assets Condition',
  DATA_COVERAEGE = 'Data Coverage',
  ASSET_TYPE = 'Asset Type',
  ASSET_ASSESSABILITY = 'Asset Assessability',
  CAMERA_INSTALLED = 'Camera Installed',
  ASSET_AREA = 'Asset Area'
}

export enum CAMERA_INSTALLED_ID {
  CAMERA = 'camera',
  NO_CAMERA = 'no-camera',
}

export enum CAMERA_INSTALLED_LABEL {
  CAMERA = 'camera',
  NO_CAMERA = 'no-camera',
}

export enum ASSETS_HEALTH_STATUS_ID {
  CRITICAL = 'critical',
  ALARM = 'alarm',
  MONITOR = 'monitor',
  HEALTHY = 'healthy',
  NA = 'na',
}

export enum ASSETS_HEALTH_STATUS_LABEL {
  CRITICAL = 'critical',
  ALARM = 'alarm',
  MONITOR = 'monitor',
  HEALTHY = 'healthy',
  NA = 'N/A',
}

export enum ASSET_ASSESSABILITY_ID {
  ASSESSABLE = 'assessable',
  NOT_ASSESSABLE = 'not-assessable',
}

export enum ASSET_ASSESSABILITY_LABEL {
  ASSESSABLE = 'Assessable',
  NOT_ASSESSABLE = 'Not Assessable',
}

export enum ASSETS_CONDITION_ID {
  STATUS_CHANGED = 'status-changed',
  NO_STATUS_CHANGE = 'no-change',
}

export enum ASSETS_CONDITION_LABEL {
  STATUS_CHANGED = 'status changed',
  NO_STATUS_CHANGE = 'no status change',
}

export enum DATA_COVERAEGE_ID {
  ONLINE = 'online-sensors',
  OFFLINE = 'offline-sensors',
  SEMI = 'semi-online-sensors',
}

export enum DATA_COVERAEGE_LABEL {
  OFFLINE = '0%-50%',
  ONLINE = '81%-100%',
  SEMI = '51%-80%',
}
